import { render, staticRenderFns } from "./SystemConfigDetail.vue?vue&type=template&id=4f7b96a8&scoped=true"
import script from "./SystemConfigDetail.vue?vue&type=script&lang=js"
export * from "./SystemConfigDetail.vue?vue&type=script&lang=js"
import style0 from "./SystemConfigDetail.vue?vue&type=style&index=0&id=4f7b96a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7b96a8",
  null
  
)

export default component.exports